const useStyles = {
  deactivateItemsList: {
    overflowY: 'scroll',
    maxHeight: '165px',
  },
}
export default useStyles
